
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1bb1"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1bb1"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bCIFA", function(module, exports) {

$parcel$export(module.exports, "register", () => $8765e4c924822d27$export$6503ec6e8aabbaf, (v) => $8765e4c924822d27$export$6503ec6e8aabbaf = v);
var $8765e4c924822d27$export$6503ec6e8aabbaf;
var $8765e4c924822d27$export$f7ad0328861e2f03;
"use strict";
var $8765e4c924822d27$var$mapping = new Map();
function $8765e4c924822d27$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$8765e4c924822d27$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $8765e4c924822d27$var$resolve(id) {
    var resolved = $8765e4c924822d27$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$8765e4c924822d27$export$6503ec6e8aabbaf = $8765e4c924822d27$var$register;
$8765e4c924822d27$export$f7ad0328861e2f03 = $8765e4c924822d27$var$resolve;

});

var $4cc42c7a810fb3c6$exports = {};

(parcelRequire("bCIFA")).register(new URL("", import.meta.url).toString(), JSON.parse('["5A6a0","index.3bf5355a.js","lA2WT","wattpad.dacae05b.svg","eyJ1k","AO3Logo.2ad5c229.svg","281wh","epub.04a23c02.svg","eHPl1","NewBadge.8f7e2e04.svg","FwlXS","FinishedBadge.f68e586d.svg","aGvXq","index.8b8551b2.css"]'));


//# sourceMappingURL=index.runtime.486973f2.js.map
